import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';

import SamsungCarePlusIcon from 'assets/images/general/samsung-care-plus.png';
import close from 'assets/images/general/close.svg';

import checkmark from 'assets/images/general/checkmark.svg';
import dash from 'assets/images/general/dash.svg';

import './SamsungCarePlusModal.scss';

export default function SamsungCarePlusModal({ isOpen, onToggle }) {
    return (
        <Modal
            isOpen={isOpen}
            centered={true}
            toggle={onToggle}
            backdrop={true}
            className='SamsungCarePlusModal'>
            <div className='SamsungCarePlusModal__container'>
                {/* Header */}
                <div className='w-100 SamsungCarePlusModal__container__header'>
                    <img
                        className='ic-close'
                        src={close}
                        onClick={onToggle}
                        alt='Close'/>
                    <div className='heading-container'>
                        <img
                            className='ic-logo'
                            src={SamsungCarePlusIcon}
                            alt='Samsung Care+'/>
                    </div>
                    <div className='heading-container mt-3'>
                        <span className='subheading'>
                            Minimize downtime.
                            <br/>
                            Maximize convenience
                        </span>
                    </div>
                </div>

                {/* Body (Comparison Table) */}
                <div className='SamsungCarePlusModal__container__content'>
                    <table className='comparison-table'>
                        <thead>
                            <tr>
                                <th className='feature-col' />
                                <th className='sc-col'>SC+</th>
                                <th className='sc-premium-col'>
                                    SC+ Premium{' '}
                                    <span className='popular-label'>Popular</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='features-main'>
                                    Extended warranty* covering up to 5 years
                                </td>
                                <td>
                                    <img src={checkmark} alt='Included' />
                                </td>
                                <td className='sc-plus-cell'>
                                    <img src={checkmark} alt='Included' />
                                </td>
                            </tr>
                            <tr>
                                <td className='features-main'>
                                    Standard SmartThings Report
                                    <br />
                                    <span className='sub-feature'>
                                        - General Usage
                                        <br />
                                        - Energy Usage
                                        <br />
                                        - Estimated Electricity Bill
                                    </span>
                                </td>
                                <td>
                                    <img src={checkmark} alt='Included' />
                                </td>
                                <td className='sc-plus-cell'>
                                    <img src={checkmark} alt='Included' />
                                </td>
                            </tr>
                            <tr>
                                <td className='features-main'>
                                    Enhanced SmartThings Report
                                    <br />
                                    <span className='sub-feature'>
                                        - Standard SmartThings report
                                        <br />
                                        - SC+ Premium Coverage Duration
                                    </span>
                                </td>
                                <td>
                                    <img src={dash} alt='Included' />
                                </td>
                                <td className='sc-plus-cell'>
                                    <img src={checkmark} alt='Included' />
                                </td>
                            </tr>
                            <tr>
                                <td className='features-main'>
                                    Maintenance Service Home Visit by Samsung Certified Technicians
                                    <br />
                                    <span className='sub-feature'>
                                        - Health Check and Diagnosis
                                        <br />
                                        - Cleaning Services
                                    </span>
                                </td>
                                <td>
                                    <img src={dash} alt='Included' />
                                </td>
                                <td className='sc-plus-cell last'>
                                    <img src={checkmark} alt='Included' />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Footer */}
                <div className='container d-flex align-items-center w-100 justify-content-center SamsungCarePlusModal__container__footer'>
                    <button
                        onClick={onToggle}
                        className='SamsungCarePlusModal__container__button'>
                        Okay
                    </button>
                </div>
            </div>
        </Modal>
    );
}

SamsungCarePlusModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func
};
